import { AxiosError } from 'axios'
import { useCallback } from 'react'
import { ErrorHandling } from '../@types/ErrorHandling'
import { useWarningStore } from '../Stores/warningStore'
import { SESSION_STORAGE } from '../constants/sessionStorage'
import { STATUS_REQUEST } from '../constants/statusRequest'
import { t } from '../i18n'

export type HandleErrorType = {
  message?: string
  error: AxiosError<ErrorHandling[]>
}

const ENVIRONMENTS = ['DV', 'TS', 'PP']

export const getErrorMessage = (errors: ErrorHandling[]) => {
  return errors.map((error) => error.message).join('\n')
}

export const useErrorRequest = () => {
  const { setWarningOptions } = useWarningStore()

  const handleErrorRequest = useCallback(
    ({ message = t('general.errors.default'), error }: HandleErrorType) => {
      let _message = message || ''

      if (error?.response?.status === STATUS_REQUEST.unauthorized) {
        _message = t('general.errors.unauthorized')
      } else if (
        error?.response?.data &&
        Array.isArray(error?.response?.data) &&
        (error?.response?.data || [])?.length > 0
      ) {
        const globalContext = JSON.parse(
          sessionStorage.getItem(SESSION_STORAGE.globalContext) || '{}',
        )

        _message = `${getErrorMessage(error.response.data)} ${
          error?.config?.headers?.traceparent &&
          ENVIRONMENTS.includes(globalContext.environment.toUpperCase() || '')
            ? t('general.errors.traceparent', {
                traceparent: error?.config?.headers?.traceparent || '',
              })
            : ''
        }`
      }

      setWarningOptions({
        labelTypes: [_message],
      })
    },
    [setWarningOptions],
  )

  return {
    handleErrorRequest,
  }
}
